import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../service/auth.service";
import { BookingService } from "../service/booking.service";
import { TranslocoService } from "@jsverse/transloco";
import { SidenavInterface } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-pages",
  template: `<div *transloco="let t">
      @if (logged) {
        <div class="dark h-screen w-screen bg-tertiary flex ">
          <std-sidenav
            [expanded]="isMenuOpen"
            childrenType="secondary"
            (onChangeExpanded)="menuChanged($event)"
            primaryColor="var(--primary)"
            secondaryColor="var(--secondary)"
            (menuClick)="goTo($event)"
            [showScrollbar]="false"
            [menuItems]="menuItems"
            textClass="text-white"
            closeMenuClass="text-primary h-100"
            (userClick)="userClick()"
            [userInfo]="userInfo"
            [closeMenu]="t('closeMenu')"
            customIconClass="w-[65%]"
            mobileOpenMenuClass="top-[24px] left-[calc(100vw-48px)] hidden"
            >
            <div
              title
              class="text-large h-[69px] pt-[30px] font-bold text-center text-white mx-[18px]"
              >
              <div class="h-[69px] mx-auto backgroundImageSidenav"></div>
            </div>
            <div
              subTitle
              class="text-large h-[69px] pt-[30px] font-bold text-center text-white mx-[18px]"
              >
              <div class="h-[69px] mx-auto backgroundImageSidenav"></div>
            </div>
          </std-sidenav>
          <div class="w-full h-screen">
            <div class="h-20 bg-tertiary shadow-lg items-center pl-4 flex">
              <std-breadcrumb
                arrowUrl="../assets/chevron-back.svg"
                [breadcrumbs]="getBreadCrumb()"
                labelItemClass="text-primary"
                endpointClass="text-primary"
                [currentElement]="currentBreadcrumb"
              ></std-breadcrumb>
              <div
                (click)="changeMenu()"
                class="ml-auto flex h-8 mr-4 items-center md:hidden place-content-center rounded-full top-[24px] w-8"
                style="background: var(--primary);"
                >
                <svg
                  height="20"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                  style="fill: white;"
                  >
                  <path
                    d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="h-[calc(100vh-80px)] overflow-y-scroll hide-bar"
          [ngClass]="{
            'w-screen md:w-[calc(100vw-221px)]': isMenuOpen,
            'w-screen md:w-[calc(100vw-90px)]': !isMenuOpen
          }"
              >
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>
      }
    </div>`,
  styles: [],
  standalone: false,
})
export class PagesComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    private booking: BookingService,
    public translocoService: TranslocoService
  ) {}
  logged = false;
  currentBreadcrumb: any = null;
  userInfo = { username: "" };
  menuItems: SidenavInterface[] = [];
  isMenuOpen = window.innerWidth > 768;
  userData: any = {};

  ngOnInit(): void {




    if (localStorage.getItem("token")) {
      this.getMe();
    } else {
      localStorage.clear();
      window.location.replace("login");
    }
  }

  changeMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  menuChanged(menuExpanded: boolean) {
    this.isMenuOpen = menuExpanded;
  }

  getMe() {
    this.translocoService.selectTranslateObject("routes").subscribe((route) => {
      this.auth.getMe().subscribe({
        next: (value: any) => {
          this.menuItems = [];
          this.userInfo.username = value.firstName + " " + value.lastName;
          localStorage.setItem("roleId", value.role);
          localStorage.setItem("user", JSON.stringify(value));
          this.userData = value;
          if (parseInt(localStorage.getItem("roleId") ?? "0") == 4) {
            this.menuItems.push({
              route: route.dashboard.path,
              text: route.dashboard.menu,
              iconUrl: "../assets/categories.svg",
            });
          }
          if (value.planActive > 0) {
            if (
              value.noOfOperators == 0 ||
              value.noOfProducts == 0 ||
              value.noOfSalons == 0 ||
              value.noOfTimetables == 0
            ) {
              this.router.navigate(["completa-profilo"]);
              this.menuItems.push({
                route: route.completeProfile.path,
                text: route.completeProfile.menu,
                iconUrl: "../assets/dashboard.svg",
              });
              if(value.noOfOperators > 0 && value.noOfSalons > 0){
                if (
                parseInt(localStorage.getItem("roleId") ?? "0") > 1 &&
                parseInt(localStorage.getItem("roleId") ?? "0") != 4
              ) {
                this.menuItems.push(
                  {
                    route: route.bookings.path,
                    text: route.bookings.menu,
                    iconUrl: "../assets/homeWhite.svg",
                  },
                  {
                    route: route.userDashboard.path,
                    text: route.userDashboard.menu,
                    iconUrl: "../assets/dashboard.svg",
                  }
                );
              }
              this.menuItems.push({
                text: route.sales.menu,
                iconUrl: "../assets/circlePlus.svg",
                childrens: [
                  {
                    text: route.sales.childrens.cash.menu,
                    route: route.sales.childrens.cash.path,
                  },
                  {
                    text: route.sales.childrens.history.menu,
                    route: route.sales.childrens.history.path,
                  },
                ],
              });
              this.menuItems.push({
                text: route.marketing.menu,
                iconUrl: "../assets/circlePlus.svg",
                childrens: [
                  {
                    text: route.marketing.childrens.reminder.menu,
                    route: route.marketing.childrens.reminder.path,
                  },
                  {
                    text: route.marketing.childrens.coupons.menu,
                    route: route.marketing.childrens.coupons.path,
                  },
                  {
                    text: route.marketing.childrens.promotion.menu,
                    route: route.marketing.childrens.promotion.path,
                  },
                ],
              });
              this.booking.getMyCompany().subscribe({
                next: (valueSub: any) => {
                  this.menuItems.push({
                    text: route.management.menu,
                    iconUrl: "../assets/circlePlus.svg",
                    childrens: [
                      { text: route.salons.menu, route: route.salons.path },
                      {
                        text: route.management.childrens.customers.menu,
                        route: route.management.childrens.customers.path,
                      },
                      {
                        text: route.management.childrens.bundles.menu,
                        route: route.management.childrens.bundles.path,
                      },
                      {
                        text: route.management.childrens.store.menu,
                        route: route.management.childrens.store.path,
                      },
                      {
                        text: route.management.childrens.store.menu,
                        route: route.management.childrens.store.path,
                      },
                      {
                        text: route.management.childrens.operatorShifts.menu,
                        route: route.management.childrens.operatorShifts.path,
                      },
                    ],
                  });
                  this.menuItems = [...this.menuItems];

                  this.logged = true;
                },
                error: (err) => {},
              });
              }
              this.logged = true;
            } else {
              if (
                parseInt(localStorage.getItem("roleId") ?? "0") > 1 &&
                parseInt(localStorage.getItem("roleId") ?? "0") != 4
              ) {
                this.menuItems.push(
                  {
                    route: route.bookings.path,
                    text: route.bookings.menu,
                    iconUrl: "../assets/homeWhite.svg",
                  },
                  {
                    route: route.userDashboard.path,
                    text: route.userDashboard.menu,
                    iconUrl: "../assets/dashboard.svg",
                  }
                );
              }
              this.menuItems.push({
                text: route.sales.menu,
                iconUrl: "../assets/circlePlus.svg",
                childrens: [
                  {
                    text: route.sales.childrens.cash.menu,
                    route: route.sales.childrens.cash.path,
                  },
                  {
                    text: route.sales.childrens.history.menu,
                    route: route.sales.childrens.history.path,
                  },
                ],
              });
              this.menuItems.push({
                text: route.marketing.menu,
                iconUrl: "../assets/circlePlus.svg",
                childrens: [
                  {
                    text: route.marketing.childrens.reminder.menu,
                    route: route.marketing.childrens.reminder.path,
                  },
                  {
                    text: route.marketing.childrens.coupons.menu,
                    route: route.marketing.childrens.coupons.path,
                  },
                  {
                    text: route.marketing.childrens.promotion.menu,
                    route: route.marketing.childrens.promotion.path,
                  },
                ],
              });
              this.booking.getMyCompany().subscribe({
                next: (valueSub: any) => {
                  this.menuItems.push({
                    text: route.management.menu,
                    iconUrl: "../assets/circlePlus.svg",
                    childrens: [
                      { text: route.salons.menu, route: route.salons.path },
                      {
                        text: route.management.childrens.customers.menu,
                        route: route.management.childrens.customers.path,
                      },
                      {
                        text: route.management.childrens.bundles.menu,
                        route: route.management.childrens.bundles.path,
                      },
                      {
                        text: route.management.childrens.store.menu,
                        route: route.management.childrens.store.path,
                      },
                      {
                        text: route.management.childrens.company.menu,
                        route: `${route.management.childrens.company.path}/${valueSub[0].id}`,
                      },
                      {
                        text: route.management.childrens.operatorShifts.menu,
                        route: route.management.childrens.operatorShifts.path,
                      },
                    ],
                  });
                  this.menuItems = [...this.menuItems];

                  this.logged = true;
                },
                error: (err) => {},
              });
            }
          } else {
            if (value.role === 4) {
              this.menuItems.push({
                text: route.salons.menu,
                route: route.salons.path,
                iconUrl: "../assets/company.svg",
              });
              this.menuItems.push({
                route: route.services.path,
                text: route.services.menu,
                iconUrl: "../assets/product.svg",
              });
              this.menuItems.push(
                {
                  route: route.categories.path,
                  text: route.categories.menu,
                  iconUrl: "../assets/categories.svg",
                },
                {
                  route: route.subCategories.path,
                  text: route.subCategories.menu,
                  iconUrl: "../assets/categories.svg",
                },
                {
                  route: route.plans.path,
                  text: route.plans.menu,
                  iconUrl: "../assets/wallet.svg",
                },
                {
                  route: route.planDesc.path,
                  text: route.planDesc.menu,
                  iconUrl: "../assets/wallet.svg",
                },
                {
                  route: route.users.path,
                  text: route.users.menu,
                  iconUrl: "../assets/users.svg",
                },
                {
                  route: route.products.path,
                  text: route.products.menu,
                  iconUrl: "../assets/product.svg",
                },
                {
                  route: route.suggestedProducts.path,
                  text: route.suggestedProducts.menu,
                  iconUrl: "../assets/product.svg",
                },
                {
                  route: route.management.childrens.companies.path,
                  text: route.management.childrens.companies.menu,
                  iconUrl: "../assets/company.svg",
                },
                {
                  route: route.subscriptions.path,
                  text: route.subscriptions.menu,
                  iconUrl: "../assets/product.svg",
                },
                {
                  route: route.resellers.path,
                  text: route.resellers.menu,
                  iconUrl: "../assets/product.svg",
                }
              );

              this.logged = true;
            } else {
              if (value.role === 5) {
                this.menuItems.push({
                  route: route.dashboard.path,
                  text: route.dashboard.menu,
                  iconUrl: "../assets/categories.svg",
                });
                this.menuItems.push({
                  text: route.management.menu,
                  iconUrl: "../assets/categories.svg",
                  childrens: [
                    {
                      route: route.management.childrens.companies.path,
                      text: route.management.childrens.companies.menu,
                    },
                    {
                      route: route.management.childrens.warehouse.path,
                      text: route.management.childrens.warehouse.menu,
                    },
                  ],
                });
                this.logged = true;
              } else {
                if(value.role === 2){
                this.menuItems.push(
                  {
                    route: route.bookings.path,
                    text: route.bookings.menu,
                    iconUrl: "../assets/homeWhite.svg",
                  },
                  // {
                  //   route: route.userDashboard.path,
                  //   text: route.userDashboard.menu,
                  //   iconUrl: "../assets/dashboard.svg",
                  // }
                );
              
              this.menuItems.push({
                text: route.sales.menu,
                iconUrl: "../assets/circlePlus.svg",
                childrens: [
                  {
                    text: route.sales.childrens.cash.menu,
                    route: route.sales.childrens.cash.path,
                  },
                  // {
                  //   text: route.sales.childrens.history.menu,
                  //   route: route.sales.childrens.history.path,
                  // },
                ],
              });
              this.menuItems.push({
                text: route.marketing.menu,
                iconUrl: "../assets/circlePlus.svg",
                childrens: [
                  {
                    text: route.marketing.childrens.reminder.menu,
                    route: route.marketing.childrens.reminder.path,
                  },
                  {
                    text: route.marketing.childrens.coupons.menu,
                    route: route.marketing.childrens.coupons.path,
                  },
                  {
                    text: route.marketing.childrens.promotion.menu,
                    route: route.marketing.childrens.promotion.path,
                  },
                ],
              });
              this.booking.getMySalons().subscribe({
                next: (valueSub: any) => {
                  this.menuItems.push({
                    text: route.management.menu,
                    iconUrl: "../assets/circlePlus.svg",
                    childrens: [
                      // {
                      //   text: route.management.childrens.customers.menu,
                      //   route: route.management.childrens.customers.path,
                      // },
                      {
                        text: route.management.childrens.bundles.menu,
                        route: route.management.childrens.bundles.path,
                      },
                      {
                        text: route.management.childrens.store.menu,
                        route: route.management.childrens.store.path,
                      },
                      {
                        text: route.management.childrens.salon.menu,
                        route: `${route.management.childrens.salon.path}/${valueSub[0].id}`,
                      },
                    ],
                  });
                  this.menuItems = [...this.menuItems];

                  
                },
                
                error: (err) => {},
              });
              this.logged = true;
                }else{
                this.router.navigate(["scegli-piano"]);}
              }
            }
          }
        },
      });
    });
  }
  getBreadCrumb() {
    let breadcrumb: any =
      this.router.routerState?.root?.children[0]?.children[0];

    if (breadcrumb) {
      if (
        breadcrumb.data?._value?.currentElement ||
        breadcrumb.data?._value?.currentElement == 0
      ) {
        this.currentBreadcrumb = breadcrumb.data?._value?.currentElement;
      } else {
        this.currentBreadcrumb = null;
      }
      return breadcrumb.data?._value?.breadcrumb;
    } else {
      return [];
    }
  }

  goTo(menuItem: any) {
    this.router.navigate([menuItem.route]);
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
  userClick() {
    this.router.navigate(["profilo"]);
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
}
